import guest from './rules/guest';
import user from './rules/user';
import analist from './rules/analist';
import president from './rules/president';
import director from './rules/director';
import worker from './rules/worker';

export default {
    guest, user,analist,director,president,worker
}